import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Location' is not assignable to p... Remove this comment to see the full error message
const params = new URL(document.location).searchParams;
const url = params.get('url');

ReactDOM.render(React.createElement(App, { url }, null), document.getElementById('root'));
